import { createFileRoute } from "@tanstack/react-router";
import HelpYourAdultChildThroughDepression from "@/pages/articles/HelpYourAdultChildThroughDepression";
export const Route = createFileRoute(
  "/help-your-adult-child-through-depression-without-taking-over",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Help Your Adult Child Through Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How to support your adult child’s depression treatment without overstepping. Practical guidance and treatment options in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Help Your Adult Child Through Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How to support your adult child’s depression treatment without overstepping. Practical guidance and treatment options in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/help-your-adult-child-through-depression-without-taking-over",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/help-your-adult-child-through-depression-without-taking-over",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HelpYourAdultChildThroughDepression />;
}
